module.exports = __webpack_public_path__ + "img/heart_process.754772cd.png";